import React from "react";

const OffCanvas = ({
  showOffCanvas,
  setShowOffCanvas,
  children,
  title,
  style,
}) => {
  return (
    <div
      className={`offcanvas offcanvas-end ${showOffCanvas ? "show" : ""}`}
      tabIndex="-1"
      style={style}
    >
      <div
        className={`offcanvas-header px-4 ${
          title ? "justify-content-between" : "justify-content-end"
        }`}
      >
        {title && <h5 className="offcanvas-title bold mb-0">{title}</h5>}
        <button
          type="button"
          className="btn-close px-1 ms-0 mr-auto"
          onClick={() => setShowOffCanvas(false)}
          data-bs-dismiss="offcanvas"
          aria-label="Close"
        ></button>
      </div>
      <div className="offcanvas-body px-4 py-0">{children}</div>
    </div>
  );
};

export default OffCanvas;
